import { createApi } from "@reduxjs/toolkit/query/react";
import { IForgotPwdPayload, IRegisterRequest, LoginRequest, LoginResponse } from "../../utils/types";
import { baseQueryWithLogout } from "../baseQuery";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: baseQueryWithLogout,
  endpoints: (builder) => ({
    loginUser: builder.mutation<LoginResponse, LoginRequest>({
      query: (credentials) => ({
        url: "/new_logins_odata",
        method: "POST",
        body: credentials,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    registerUser: builder.mutation<{ message: string; success: boolean }, IRegisterRequest>({
      query: (credentials) => ({
        url: "/register_vendor_user",
        method: "POST",
        body: credentials,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    getVerifyVendor: builder.mutation<{ message: string; success: boolean }, any>({
      query: (credentials) => {
        return {
          url: "/api_vendor_info_odata?vendor_code=" + credentials,
          method: "GET",
        };
      },
    }),
    sendOtp: builder.mutation<{ message: string; success: boolean }, { mobile: string, type?: string }>({
      query: (credentials) => ({
        url: "/generate_otp",
        method: "POST",
        body: credentials,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    verifyOTP: builder.mutation<any, { otp: string; phone_number: string }>({
      query: (credentials) => ({
        url: "/validate_otp",
        method: "POST",
        body: credentials,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    forgotPassword: builder.mutation<{ message: string; success: boolean }, IForgotPwdPayload>({
      query: (credentials) => ({
        url: "/forgot_password",
        method: "POST",
        body: credentials,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    getVendorDetailswithCode: builder.mutation<{ message: string; success: boolean }, any>({
      query: (credentials) => ({
        url: "/forgot_password_vendor",
        method: "POST",
        body: credentials,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    logoutUser: builder.mutation<any, any>({
      query: (data) => {
        const formData = new FormData();
        for (const key in data) {
          if (data[key] !== undefined && data[key] !== null) {
            formData.append(key, data[key]);
          }
        }

        return {
          url: "/logout",
          method: "POST",
          body: formData,
          // Note: Do NOT set 'Content-Type' when using FormData;
          // the browser will automatically set it to 'multipart/form-data' with the correct boundary.
        };
      },
    }),
    getApiCheckPerner: builder.query({
      query: (payload) => ({
        url: "/api/check-perner?perner=" + payload,
        method: "GET",
      }),
    }),
    getUserRole: builder.mutation({
      query: (payload) => {
        return {
          url: '/get_employee_role?' + payload,
          method: "GET",
        };
      },
    }),

  }),
});

export const {

  useGetUserRoleMutation,
  useGetApiCheckPernerQuery,
  useGetVendorDetailswithCodeMutation,
  useLoginUserMutation,
  useLogoutUserMutation,
  useRegisterUserMutation,
  useSendOtpMutation,
  useVerifyOTPMutation,
  useForgotPasswordMutation,
  useGetVerifyVendorMutation,
} = authApi;
